import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import AddOperatingCostItemForm from "./AddOperatingCostItemForm";
import AddOperatingCostTypeForm from "./AddOperatingCostTypeForm";
import { addData, clearQueryResult, queryCostItem, queryCostType } from "../../actions/valueActions";


const AddOperatingCostData = ({ id, industry, type, cost_category, costTypes, filterCosts, handleClose }) => {
    const formikRef = useRef(null);
    const dispatch = useDispatch();

    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);

    const queryResult = useSelector(state => state.value.queryResult)

    const handleTabChange = (event, newValue) => {
        dispatch(clearQueryResult())
        setTab(newValue);
    };

    const addCostFormAction = () => {
        return (
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    type="submit"
                    disabled={loading}
                    sx={{ textTransform: 'none' }}
                >
                    Request
                </Button>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',  // half of 24
                            marginLeft: '-12px', // half of 24
                            zIndex: 1,
                        }}
                    />
                )}
            </Box>
        )
    }

    const saveCostFormAction = () => {
        return (
            <React.Fragment>
                <Button
                    startIcon={<SaveIcon />}
                    type="submit"
                    sx={{ textTransform: 'none' }}
                >
                    Save
                </Button>
                <Button
                    startIcon={<AutoFixHighIcon />}
                    onClick={() => dispatch(clearQueryResult())}
                    sx={{ textTransform: 'none' }}
                >
                    Rerun Request
                </Button>
            </React.Fragment>
        )
    }

    const onSubmitCostItem = async (values, { setSubmitting }) => {
        values.industry = industry
        values.cost_category = cost_category

        setLoading(true)
        let success = false

        const result = await dispatch(queryCostItem(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitCostType = async (values, { setSubmitting }) => {
        values.industry = industry
        values.cost_category = cost_category

        setLoading(true)
        let success = false

        const result = await dispatch(queryCostType(id, values, { setSubmitting }))

        success = result?.success;
        setLoading(false)

        if (formikRef.current && !success) {
            formikRef.current.resetForm();
        }
    }

    const onSubmitSaveCostItem = (values) => {
        values.lower = values.lower.toString().replace(/,/g, "");
        values.higher = values.higher.toString().replace(/,/g, "");

        dispatch(addData(id, type, 'cost_sub_type', values))

        handleClose()
    }

    const onSubmitSaveCostType = (values) => {
        let costPerMultiple = values.cost_per_multiple

        Object.keys(costPerMultiple).forEach(subType => {
            costPerMultiple[subType].lower = costPerMultiple[subType].lower.toString().replace(/,/g, '');
            costPerMultiple[subType].higher = costPerMultiple[subType].higher.toString().replace(/,/g, '');
        });

        values.cost_per_multiple = costPerMultiple

        dispatch(addData(id, type, 'cost_type', values))

        handleClose()
    }

    function renderAddCostItem() {
        // dispatch(clearQueryResult())

        return (
            <AddOperatingCostItemForm
                costTypes={costTypes}
                filterCosts={filterCosts}
                queryResult={queryResult}
                formActions={addCostFormAction}
                formResultActions={saveCostFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitCostItem(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveCostItem}
                ref={formikRef}
            />
        )
    }

    function renderAddCostType() {
        // dispatch(clearQueryResult())

        return (
            <AddOperatingCostTypeForm
                costTypes={costTypes}
                queryResult={queryResult}
                formActions={addCostFormAction}
                formResultActions={saveCostFormAction}
                onSubmit={(values, { setSubmitting }) => onSubmitCostType(values, { setSubmitting })}
                onSubmitResult={onSubmitSaveCostType}
                ref={formikRef}
            />
        )
    }

    return (
        <Box>
            <Tabs
                value={tab}
                onChange={handleTabChange}
                sx={{ mb: 2, textTransform: 'none' }}
            >
                <Tab label="Add Cost Sub Type" />
                <Tab label="Add Cost Type" />
            </Tabs>
            {tab === 0 &&
                renderAddCostItem()
            }
            {tab === 1 &&
                renderAddCostType()
            }
        </Box>
    )
}

export default AddOperatingCostData 